module.exports = __webpack_public_path__ + "img/filtersorticon.70976e15.svg";